import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

import { IWorkspaceSummary } from '../../../../../shared/interfaces/workspace.interface';
import { WorkspaceService } from '../../../services/workspace.service';
import { Api } from '../../../../../shared/constants/api';
import { $workspace, $workspaceSummary } from '../../../../../shared/constants/workspace';
import { IDigitalProperty } from '../../../../../shared/interfaces/digital-property.interface';
import { DigitalPropertyService } from '../../../services/digital-property.service';

@Component({
  selector: 'app-tenant-workspace-details',
  templateUrl: './workspace-details.component.html',
  styleUrls: ['./workspace-details.component.scss'],
  standalone: false,
})
export class TenantWorkspaceDetailsComponent implements OnInit {
  public wsSummary$: Observable<IWorkspaceSummary>;
  public digitalProperties$: Observable<IDigitalProperty[]>;

  public workspaceId: string = '';
  public $workspace: typeof $workspace = $workspace;
  public $workspaceSummary: typeof $workspaceSummary = $workspaceSummary;

  constructor(
    private activatedRoute: ActivatedRoute,
    private workspaceService: WorkspaceService,
    private digitalPropertyService: DigitalPropertyService,
  ) {}

  public ngOnInit(): void {
    this.workspaceId = this.activatedRoute.snapshot.params[Api.workspaceId];
    this.wsSummary$ = this.workspaceService.getWorkspaceSummary(this.workspaceId);
    this.digitalProperties$ = this.digitalPropertyService.getAllDigitalPropertiesByWorkspaceId(this.workspaceId);
  }
}
